module.exports = __webpack_public_path__ + "img/nor_jn_moun1.f46ba0a9.png";